<template>
    <div class="document-list-wrapper container-fluid p-t-25 p-r-0 p-l-0">
        <!-- ERROR MESSAGES -->

        <div class="raised low p-25 text-center" v-if="docTypes.length == 0" v-cloak>
            You do not have access to the documents on this page.
        </div>

        <div class="raised low p-25 text-center" v-else-if="errorMessage" v-cloak>
            {{ errorMessage }}
        </div>

        <div class="raised low p-25 text-center" v-else-if="accounts.length == 0 && user_is_sys_admin" v-cloak>
            System administrators must select an account to view documents
        </div>

        <div class="raised low p-25 text-center" v-else-if="docTypes.length > 1 && selectedDocTypeCodes.length == 0"
            v-cloak>
            Please select a document type to view documents
        </div>

        <div class="raised low p-25 text-center" v-else-if="isRetreivingDocuments" style="font-size:1.5em" v-cloak>
            Loading...
        </div>

        <!-- DOCUMENT LIST -->
        <div class="document-list-container" v-else>
            <document-list v-show="!errorMessage && !isRetreivingDocuments && documents.length > 0"
                :documents="currentDocuments" :all_expanded="allExpanded" :document_type="document_type"
                :accounts="accounts" @search="performSearch" @change_view="goToGrid"
                @reset_page="resetPage"></document-list>


            <paginator class="p-t-10 p-r-25 p-b-10 p-r-25" :available_page_sizes="[50, 100, 250, 500]"
                :initial_page_size="documentsPerPage" :current_page="page" :current_page_size="documentsPerPage"
                :number_of_items="totalDocuments" :filtered_from="documents.length" :disabled="isRetreivingDocuments"
                @change="changePagination"></paginator>
        </div>
    </div>
</template>

<style lang="scss">
@import 'resources/assets/sass/global_variables';
</style>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

module.exports = {
    props: {
        user_is_sys_admin: { default: null },
        accounts: { default: function () { return [] } },
        document_type: String
    },

    data: function () {
        return {
            initialReportCount: 500,
            maxRecords: 5000,
            page: 1,
            documentsPerPage: 100,
            isRetreivingDocuments: false,
            errorMessage: null,
            partialReportResults: []
        }
    },

    computed: {
        ...mapState('documents', {
            docTypes: 'docTypes',
            documents: 'rows',
            needToSearch: 'needToSearch',
            selectedSampleTypes: 'selectedSampleTypes',
            selectAllChecked: 'selectAllChecked'
        }),

        ...mapGetters('documents', {
            visibleDocuments: 'specificPageRows',
            filteredDocuments: 'visibleRows',
            selectedDocTypeCodes: 'selectedDocTypeCodes',
            selectedRows: 'selectedRows'
        }),

        totalDocuments: function () {
            return this.filteredDocuments.length;
        },

        currentDocuments: function () {
            return this.visibleDocuments({
                page: this.page,
                itemsPerPage: this.documentsPerPage
            })
        },

        partialReportResultsFormatted: function () {
            let samples = [];
            for (let key in this.partialReportResults) {
                if (!this.partialReportResults.hasOwnProperty(key)) continue;
                samples.push({ id: key, items: this.partialReportResults[key] });
            }
            return samples;
        },

        allExpanded() {
            return this.currentDocuments.filter(doc => doc.expandable && !doc.expanded).length == 0
        },
        filteredAccounts() {
            if (this.user_is_sys_admin) {
                return this.accounts;
            }
            return this.accounts.filter(acc => !acc.is_credit_and_collection);
        },
    },

    methods: {
        ...mapActions('documents', [
            'updateRows', 'searchUpdated', 'selectRow', 'deselectRow', 'checkSelectAllButton',
            'changeStartDate', 'changeEndDate', 'setItemValue'
        ]),

        resetPage() {
            this.page = 1;
        },

        goToGrid: function () {
            this.$emit('change_view', 'results');
        },

        queueSearch: function () {
            if (this.accounts.length > 0) {
                this.performSearch();
            }
        },

        performSearch: function () {
            if (!this.needToSearch) {
                return;
            }
            this.errorMessage = null;
            this.page = 1;
            this.getDocuments(function (response) {
                if (this.documents.length == 0) this.errorMessage = 'No documents found.  Please refine your search and try again.';
            }, function (response) {
                this.errorMessage = 'There was an error retrieving the documents.  You may need to narrow the date range on your search.';
            });
        },

        getDocuments: function (success, error) {
            let vm = this;
            this.isRetreivingDocuments = true;
            this.documents.splice(0, this.documents.length);
            this.updateRows({ rows: [], filter_data: [] });
            let params = {};
            params.accountNbrs = [];
            for (let i = 0; i < this.filteredAccounts.length; i++) {
                params.accountNbrs.push(this.filteredAccounts[i].account_nbr);
            }

            let request = this.$http.post('/documents/sds/list', params);
            request.then(function (response) {
                if (response.data) {
                    this.updateRows({
                        rows: response.data.documents
                    });
                    this.searchUpdated(false);
                    if (typeof success === 'function') success.call(this, response);
                }
                this.isRetreivingDocuments = false;
            }, function (response) {
                this.documents.splice(0, this.documents.length);
                this.isRetreivingDocuments = false;
                if (typeof error === 'function') error.call(this, response);
            });
        },

        changePagination: function (pageNumber, itemsPerPage) {
            this.page = pageNumber;
            this.documentsPerPage = itemsPerPage;
        }
    }
}
</script>



// WEBPACK FOOTER //
// safety-data-sheet-list.vue?0cb4e874